import React, { useEffect, useState } from "react";
import { SupportedLanguage } from "@src/types/orgSettings";
import Modal from "@components/atoms/Modal";
import RadioButton from "@components/atoms/RadioButton";
import { Button, Spacer } from "@components/atoms";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";

type LocationsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  languages: SupportedLanguage[];
  selectedLocation: SupportedLanguage | null;
  changeLocation: (lan: any | undefined) => void;
  isMatchPair?: boolean;
};

const Locations = ({
  isOpen,
  onClose,
  languages,
  selectedLocation,
  changeLocation,
  title,
}: LocationsModalProps) => {
  const [selectedLang, setSelectedLang] = useState(selectedLocation);
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedLang(selectedLocation);
  }, [selectedLocation]);

  const handleLanguageChange = (language: any) => {
    setSelectedLang(language);
  };

  const handleDoneClick = () => {
    changeLocation(selectedLang);
    onClose();
  };
  return (
    <Modal
      headerTitle={t(title || "productDetailPage.popup.locationTitle.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={40}
      paddingTop={16}
    >
      <ScrollView keyboardShouldPersistTaps={"always"}>
        {languages &&
          languages.length &&
          languages.map((language, i) => {
            return (
              <RadioButton
                key={i}
                label={language?.location_name}
                labelColor={
                  language.code === `${selectedLocation?.id}`
                    ? theme["core-05"]
                    : theme["core-06"]
                }
                checked={language.id === selectedLang?.id}
                onPress={() => handleLanguageChange(language)}
              />
            );
          })}
      </ScrollView>
      <Spacer size={SpaceType.Big} />
      <Button
        category={ButtonCategory.default}
        type={ButtonType.primary}
        title={t("global.text.done")}
        onPress={handleDoneClick}
      />
    </Modal>
  );
};

export default Locations;
